import facebook from 'assets/images/svg/new-plan/footer/facebook.svg';
import instagram from 'assets/images/svg/new-plan/footer/instagram.svg';
import wspIcon from 'assets/images/svg/new-plan/footer/whatsapp.svg';
import { WHATSAPP_LINK } from 'domains/new-plan/constants/whatsapp';

import './footer.scss';

const Footer = () => {
  return (
    <div className="footer-blue">
      <div className="footer-blue__container">
        <div className="footer-blue__container__content">
          <div className="footer-blue__container__content__media">
            <p>Síguenos en Redes sociales</p>
            <div className="footer-blue__container__content__icons">
              <a
                href="https://www.facebook.com/PacificoSeguros"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebook} alt="facebook" />
              </a>
              <a
                href="https://www.instagram.com/pacifico_seguros/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="instagram" />
              </a>
            </div>
          </div>
          <div className="footer-blue__container__content__contact">
            <p>Te ayudamos con tu compra</p>
            <div className="footer-blue__container__content__contact__icons">
              <p className="footer-blue__container__content__contact__icons--text">
                WHATSAPP
              </p>
              <button className="footer-blue__container__content__contact__icons--button">
                <img src={wspIcon} alt="phone icon" />
                <a href={WHATSAPP_LINK} target="_blank">
                  981 791 721
                </a>
              </button>
            </div>
          </div>
        </div>
        <p className="footer-blue__container__rights">
          *Esta clasificación se obtuvo de Fuente: Apoyo y asociados
          <br />
          Esta página web está protegida por reCAPTCHA y se aplican las
          Políticas de privacidad y los Términos de servicio de Google.
        </p>
        <p className="footer-blue__container__rights">
          20332970411 - PACÍFICO COMPAÑIA DE SEGUROS Y REASEGUROS
        </p>
      </div>
    </div>
  );
};

export default Footer;
